/**
 * Cross-project navigation utility for BXI Landing
 * Handles navigation between landing and dashboard projects
 */

/**
 * Navigate to dashboard project
 * @param {string} path - Path within dashboard (e.g., '/', '/dashboard', '/cart')
 */
export const navigateToDashboard = (path = '/') => {
  const dashboardUrl = window.DASHBOARD_URL || process.env.REACT_APP_DASHBOARD_URL || 'http://localhost:3001';
  const fullUrl = `${dashboardUrl}${path.startsWith('/') ? path : `/${path}`}`;
  window.location.href = fullUrl;
};

/**
 * Navigate to landing project
 * @param {string} path - Path within landing (e.g., '/', '/about', '/blog')
 */
export const navigateToLanding = (path = '/') => {
  const landingUrl = window.location.origin;
  const fullUrl = `${landingUrl}${path.startsWith('/') ? path : `/${path}`}`;
  window.location.href = fullUrl;
};

/**
 * Check if user should be redirected to dashboard after login
 * @param {boolean} isLoggedIn - Whether user is logged in
 * @returns {boolean}
 */
export const shouldRedirectToDashboard = (isLoggedIn) => {
  return isLoggedIn;
};

/**
 * Get dashboard URL for a specific path
 * @param {string} path - Path within dashboard
 * @returns {string}
 */
export const getDashboardUrl = (path = '/') => {
  const dashboardUrl = window.DASHBOARD_URL || process.env.REACT_APP_DASHBOARD_URL || 'http://localhost:3001';
  return `${dashboardUrl}${path.startsWith('/') ? path : `/${path}`}`;
};
